<template>
  <el-dialog
    class="dialog-container"
    :title="title"
    :visible.sync="dialogVisible"
    width="550px"
    append-to-body
  >
    <!-- 表格内容 -->
    <div class="table-container">
      <el-table
        ref="tableRef"
        :border="true"
        stripe
        :data="vinList"
      >
        <!-- 序号 -->
        <el-table-column
          label="序号"
          width="60px"
          align="center"
          type="index"
        ></el-table-column>
        <!-- 故障车VIN码 -->
        <el-table-column
          prop="vin"
          label="故障车VIN码"
          min-width="120px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="vinCreated"
          label="生产日期"
          min-width="120px"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <!-- 故障车发动机编号 -->
        <!-- <el-table-column
          v-if="carAttribute === 0 && faultType !== 5"
          prop="engineNumber"
          label="故障车发动机编号"
          min-width="120px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column> -->
        <!-- 车身颜色 -->
        <!-- <el-table-column
          v-if="carAttribute === 0 && faultType === 5"
          prop="carColor"
          label="车身颜色"
          min-width="120px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column> -->
        <!-- 故障车电机号 -->
        <!-- <el-table-column
          v-if="carAttribute === 1"
          prop="motorModel"
          label="故障车电机号"
          min-width="120px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column> -->
      </el-table>
    </div>
    <!-- <div slot="footer" class="text-center">
      <el-button @click="dialogVisible = false">返回</el-button>
    </div> -->
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      title: "",
      dialogVisible: false,
      carAttribute: null,
      faultType: null,
      vinList: []
    };
  },
  mounted() {},
  methods: {
    // 初始化
    async init(title, carAttribute, faultType, data = []) {
      this.title = title;
      this.carAttribute = carAttribute;
      this.faultType = faultType;
      this.vinList = data || [];
      this.dialogVisible = true;
    }
  }
};
</script>
